const settings = {
  pageTitle: 'सेटिंग्स',
  pageSubtitle: 'स्कूल-व्यापी मास्टर डेटा और कॉन्फ़िगरेशन प्रबंधित करें',
  classMaster: 'कक्षा मास्टर',
  rolesMaster: 'भूमिका मास्टर',
  sections: 'अनुभाग',
  general: 'सामान्य',
  calendarSettings: 'कैलेंडर सेटिंग्स',
  generalSettingsTitle: 'सामान्य सेटिंग्स',
  generalSettingsDescription: 'स्कूल प्रोफ़ाइल, शैक्षणिक वर्ष कॉन्फ़िगरेशन और अन्य वैश्विक प्राथमिकताएं यहां उपलब्ध होंगी। अभी के लिए, अपना मास्टर डेटा प्रबंधित करने के लिए <strong>कक्षा मास्टर</strong>, <strong>भूमिका मास्टर</strong>, और <strong>अनुभाग</strong> टैब का उपयोग करें।',
  goToClassMaster: 'कक्षा मास्टर पर जाएं',
  classMasterDescription: 'स्कूल में उपयोग किए जाने वाले सभी कक्षा नामों को परिभाषित और प्रबंधित करें। संपादन लचीले हैं — हर स्कूल अपनी नामकरण परंपराओं का उपयोग करता है।',
  noClassesDefined: 'अभी तक कोई कक्षा परिभाषित नहीं है। आरंभ करने के लिए अपनी पहली कक्षा जोड़ें।',
  rolesMasterDescription: "स्टाफ़ भूमिकाओं और पदनामों का प्रबंधन करें। अपने स्कूल की संगठनात्मक संरचना से मेल खाने के लिए कस्टम भूमिकाएं जोड़ें।",
  noRolesDefined: 'अभी तक कोई भूमिका परिभाषित नहीं है। आरंभ करने के लिए अपनी पहली भूमिका जोड़ें।',
  sectionsDescription: 'A, B, C जैसे कक्षा अनुभागों या आपके स्कूल द्वारा उपयोग किए जाने वाले किसी भी कस्टम अनुभाग लेबल का प्रबंधन करें।',
  noSectionsDefined: 'अभी तक कोई अनुभाग परिभाषित नहीं है। आरंभ करने के लिए अपना पहला अनुभाग जोड़ें।',
  addButton: '{{type}} जोड़ें',
  enterName: 'नाम दर्ज करें...',
  moveUp: 'ऊपर ले जाएं',
  moveDown: 'नीचे ले जाएं',
  deleteConfirm: 'हटाएं?',
  classesDefined: 'कक्षाएं परिभाषित',
  rolesConfigured: 'भूमिकाएं कॉन्फ़िगर',
  sectionsDefined: 'अनुभाग परिभाषित',
  itemCount: '{{count}} आइटम',
  itemCountPlural: '{{count}} आइटम',
  settingsBreadcrumb: 'सेटिंग्स',
  awarenessEventsMaster: 'जागरूकता कार्यक्रम मास्टर',
  holidayMaster: 'छुट्टी मास्टर',
};

export default settings;